export default __webpack_public_path__ + "static/media/bruce-springsteen.5e650871.webp";